import { ApiGetRequest } from 'types';

import { IUserRole } from 'modules/auth-session';

export enum EAppNotificationSource {
  EECS_FORWARD = 'eecs_forward',
  EECS_PACKAGE = 'eecs_package',
  EECS_TRANSACTION = 'eecs_transaction',
  EECS_BID = 'eecs_bid',
  EECS_TRADE = 'eecs_trade',
  CUSTOM = 'platform_notifications',
}

export interface IAppNotification {
  id: number;
  title: string;
  date: number;
  source: EAppNotificationSource | null;
  source_id: number | null;
  is_read: boolean;
  roles: IUserRole[];
  link?: string | null;
}

export interface UnreadNotificationResponse {
  unread_count: number;
}

export interface FetchAppNotificationPayload extends ApiGetRequest {}

export interface UpdateNotificationPayload {
  id: number;
  is_read: boolean;
  is_clicked_link?: boolean;
}

export interface NotificationEventPayload {
  payload: {
    unread_count: number;
    notification: IAppNotification | null;
  };
}
